import { combineReducers } from "redux";
import { account } from "./accountReducer";

const accountReducers = combineReducers({
  account,
});

export default accountReducers;
